import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useLang } from '@/context/LanguageContext';

const PricingSection = () => {
  const { t, translations, lang } = useLang();
  const features = translations.pricing.features;

  return (
    <section data-testid="pricing-section" className="py-24 md:py-32 bg-[#F5F1EC]">
      <div className="px-5 md:px-10 lg:px-14 max-w-7xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <p className="text-[11px] uppercase tracking-[0.3em] text-[#E92A3E] mb-4">
            {t('pricing.label')}
          </p>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-[#111] leading-tight mb-6">
            {t('pricing.title')}
          </h2>
          <p className="text-base text-[#555] max-w-2xl mx-auto leading-relaxed mb-4">
            {t('pricing.desc')}
          </p>
          <p className="text-sm text-[#888] max-w-xl mx-auto leading-relaxed whitespace-pre-line mb-12">
            {t('pricing.subdesc')}
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="grid md:grid-cols-3 gap-6 mb-14 max-w-4xl mx-auto"
        >
          {features.map((f, i) => (
            <div key={i} className="text-left p-5 rounded-lg border border-[#D9D3CC]">
              <h4 className="font-heading font-bold text-sm text-[#111] mb-2">
                {f.title[lang]}
              </h4>
              <p className="text-sm text-[#555] leading-relaxed">{f.desc[lang]}</p>
            </div>
          ))}
        </motion.div>

        <Link to="/inquiry" data-testid="pricing-cta" className="btn-primary rounded inline-block">
          {t('pricing.cta')}
        </Link>
        <p className="text-xs text-[#888] mt-5">{t('pricing.note')}</p>
        <div className="mt-6 inline-flex items-center gap-2" data-testid="pricing-urgency">
          <span className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse" />
          <span className="text-xs text-[#888] tracking-wide uppercase">
            {t('pricing.urgency')}
          </span>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
